import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { PageState } from '@Core/models/proprietary/page/page.state';
import { EvaluatedStateObject } from '@Core/services/proprietary/object-rule/object-rule.types';

@Component({
    standalone: false,
    selector: 'validation-dialog',
    templateUrl: './validation-dialog.component.html',
    providers: []
})
export class ValidationDialogComponent {
    @Select(PageState.evaluatedStateObjects)
    evaluatedStateObjects$: Observable<EvaluatedStateObject[]>;
    // @Select(DocumentDistributeObjectState.documents)
    // documents$: Observable<any>;

    // @Select(DocumentDistributeObjectState.documentCount)
    // documentCount$: Observable<any>;

    // @Select(DocumentDistributeObjectState.filings)
    // filings$: Observable<any>;

    // filingsByDocID$: Observable<any>;

    // _docList: any = [];

    // public model = {
    //   currentDocID: null
    // };

    // public objectDisplayName: string;
    // public objectType: string;
    // private documentsSub: Subscription;
    protected parentActiveModal: NgbActiveModal;

    // documentDistributePageMenu = {
    //   objectNode: {
    //     Menu_Item: [
    //       {
    //         Label: 'Add Recipient',
    //         Url: ['/action/addrecipient', {}]
    //       },
    //       {
    //         Label: 'Clear All Recipients',
    //         Url: ['/action/clearrecipients', {}]
    //       }
    //     ]
    //   }
    // };

    // menuHandler(action: any) {
    //   switch (action.Action_Code) {
    //     case 'addrecipient':
    //       this.recipientSearch();
    //       break;

    //     case 'clearrecipients':
    //       this.documentDistributeOS.removeAllFilingsForDocID(this.model.currentDocID);
    //       break;

    //     default:
    //       console.error('Unhandled Menu Action: ' + JSON.stringify(action));
    //   }
    // }

    constructor(private injector: Injector, private activeModal: NgbActiveModal, private store: Store) {
        this.parentActiveModal = this.activeModal;
    }

    // ngOnDestroy() {
    //   if (this.documentsSub) {
    //     this.documentsSub.unsubscribe();
    //   }
    // }

    getObjectDesc(object: any) {
        let desc = object.objectNode;
        let recordKey = object.stateObject + '.$Record';
        if (object.fieldRuleResults && object.fieldRuleResults[recordKey]) {
            if (object.fieldRuleResults[recordKey].desc > '') {
                desc = object.fieldRuleResults[recordKey].desc;
            }
        }
        return desc;
    }

    getObjectErrors(object: any) {
        let errors: string[] = [];
        if (object.error) {
            //critical object definition error
            errors.push(object.error);
        }
        if (object.fieldRuleResults) {
            for (var field in object.fieldRuleResults) {
                if (object.fieldRuleResults[field].validationRules) {
                    object.fieldRuleResults[field].validationRules.forEach((error) => {
                        errors.push(error.message);
                    });
                }
            }
        }
        return errors;
    }

    closeModal(returnValue: any) {
        if (this.parentActiveModal) {
            this.parentActiveModal.close(returnValue);
            return;
        } else {
            throw 'Dialog did not properly set parentActiveModal in "initialize()"';
        }
    }

    close() {
        this.closeModal({ action: 'Close' });
    }

    cancel() {
        this.closeModal({ action: 'Cancel' });
    }
}
